var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReviewWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.86,
    height: 20.796,
    viewBox: "0 0 18.86 20.796",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1585",
    "data-name": "Group 1585",
    transform: "translate(0.223)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_201",
    "data-name": "Path 201",
    d: "M116.451,200.812a.812.812,0,0,0-.812-.812h-8.367a.812.812,0,0,0,0,1.625h8.367A.812.812,0,0,0,116.451,200.812Z",
    transform: "translate(-103.214 -191.877)",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_202",
    "data-name": "Path 202",
    d: "M107.271,280a.812.812,0,0,0,0,1.625h5.082a.812.812,0,1,0,0-1.625Z",
    transform: "translate(-103.214 -268.627)",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_203",
    "data-name": "Path 203",
    d: "M32.536,19.171H29.819a1.627,1.627,0,0,1-1.625-1.625V3.249a1.627,1.627,0,0,1,1.625-1.625h9.987a1.627,1.627,0,0,1,1.625,1.625v5a.812.812,0,1,0,1.625,0v-5A3.253,3.253,0,0,0,39.807,0H29.819A3.253,3.253,0,0,0,26.57,3.249v14.3A3.253,3.253,0,0,0,29.819,20.8h2.717a.812.812,0,1,0,0-1.625Z",
    transform: "translate(-26.793)",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_204",
    "data-name": "Path 204",
    d: "M252.573,272.737a2.44,2.44,0,0,0-3.446,0l-4.46,4.45a.812.812,0,0,0-.2.339l-.971,3.2a.812.812,0,0,0,.994,1.019l3.279-.908a.812.812,0,0,0,.357-.208l4.451-4.442A2.44,2.44,0,0,0,252.573,272.737Zm-5.447,6.588-1.65.457.483-1.589,3.009-3,1.149,1.149Zm4.3-4.291-.157.157-1.149-1.149.157-.157a.812.812,0,0,1,1.149,1.148Z",
    transform: "translate(-234.648 -260.975)",
    fill: "#e85257"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_205",
    "data-name": "Path 205",
    d: "M115.639,120h-8.367a.812.812,0,0,0,0,1.625h8.367a.812.812,0,1,0,0-1.625Z",
    transform: "translate(-103.214 -115.126)",
    fill: "#FFF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewWhite);
export default __webpack_public_path__ + "static/media/ReviewWhite.590c056093e4a370bfe698abeb9b3b0b.svg";
export { ForwardRef as ReactComponent };